import { useState } from 'react'
import { Link } from 'react-router-dom'
import { useAuthStore } from '../../store/authStore'
import { Mail } from 'lucide-react'
import toast from 'react-hot-toast'

export default function ForgotPassword() {
  const { resetPassword } = useAuthStore()
  const [email, setEmail] = useState('')
  const [isLoading, setIsLoading] = useState(false)
  const [sent, setSent] = useState(false)

  const handleSubmit = async (e) => {
    e.preventDefault()
    setIsLoading(true)
    const result = await resetPassword(email)
    if (result.success) {
      setSent(true)
      toast.success('Revisa tu correo para restablecer tu contraseña')
    } else {
      toast.error(result.error || 'Error al enviar el correo')
    }
    setIsLoading(false)
  }

  return (
    <div className="min-h-screen bg-gradient-to-br from-kiniela-bg to-kiniela-accent flex items-center justify-center px-4 sm:px-6 lg:px-8">
      <div className="max-w-md w-full space-y-8 bg-kiniela-card p-8 rounded-2xl shadow-2xl border border-kiniela-border">
        <div>
          <h2 className="text-3xl font-bold text-center text-kiniela-gold">¿Olvidaste tu contraseña?</h2>
          <p className="mt-2 text-center text-sm text-kiniela-muted">
            Ingresa tu email y te enviaremos instrucciones para restablecerla.
          </p>
        </div>
        {sent ? (
          <div className="text-center text-kiniela-success font-medium space-y-4">
            <div>¡Correo enviado! Revisa tu bandeja de entrada.</div>
            <Link to="/" className="inline-block mt-4 btn btn-secondary">
              ← Volver al inicio
            </Link>
          </div>
        ) : (
          <form className="mt-8 space-y-6" onSubmit={handleSubmit}>
            <div>
              <label htmlFor="email" className="block text-sm font-medium text-kiniela-text mb-1">
                Email
              </label>
              <div className="relative">
                <Mail className="absolute left-3 top-1/2 transform -translate-y-1/2 text-kiniela-muted" size={20} />
                <input
                  id="email"
                  name="email"
                  type="email"
                  required
                  value={email}
                  onChange={e => setEmail(e.target.value)}
                  className="pl-10 input"
                  placeholder="tu@email.com"
                />
              </div>
            </div>
            <button
              type="submit"
              disabled={isLoading}
              className="w-full btn btn-primary py-3 text-lg"
            >
              {isLoading ? 'Enviando...' : 'Enviar instrucciones'}
            </button>
            <p className="text-center text-sm text-kiniela-muted">
              <Link to="/login" className="font-medium text-kiniela-gold hover:text-kiniela-gold/80">
                Volver al login
              </Link>
            </p>
          </form>
        )}
      </div>
    </div>
  )
}
